import { AudioPlayerSmall as AudioPlayer } from "ae-base/Base/AudioPlayer";
import StyledButton from "ae-base/Base/StyledButton";
import StyledIcon from "ae-base/Base/StyledIcon";
import StyledText from "ae-base/Base/StyledText";
import ListContent from "ae-base/List/ListContent";
import ListItem from "ae-base/List/ListItem";
import Style from "ae-style";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Image, View } from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

var styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		previewImage: {
			width: 64,
			height: 64,
			alignSelf: "flex-end",
			margin: Style.layout.marginSlim
		},
		previewAudio: {
			width: 128,
			height: 32,
			alignSelf: "flex-end",
			margin: Style.layout.marginSlim
		},
		previewText: {
			margin: Style.layout.marginSmall,
			alignItems: "center"
		},
		newMessage: {
			alignSelf: "center"
		},
		removeButtonContainer: {
			justifyContent: "flex-start",
			width: "100%",
			flexDirection: "row"
		},
		contentContainer: {
			flexDirection: "row",
			alignItems: "center"
		},
		mediaSelectContainer: {
			flexDirection: "column",
			marginVertical: Style.layout.marginSmall
		},
		listItemContainer: {
			justifyContent: "space-between",
			flexWrap: "wrap"
		}
	},
	512: {
		previewText: {
			margin: Style.layout.marginLarge
		},
		contentContainer: {
			flexDirection: "row"
		}
	}
});

export default class FilePreview extends Component {
	constructor() {
		super();
		this.state = {
			preview: null
		};
		this.getPreview = getPreview.bind(this);
	}
	render() {
		var context = this.context;
		var props = this.props;
		var localize = context.localize;
		var onRemove = props.onRemove;
		var file = props.file || {};
		var toUpload = file.file;
		var format = file.format || toUpload.format;
		var url = file.url || toUpload.url || "";
		var newFile = localize("filelist.new");
		var remove_title = localize("filelist.remove");
		var contrast = props.contrast;

		var name = (toUpload ? toUpload.name : url.split("-").slice(-1)[0]) || "";
		var extension = name.split(".").slice(-1)[0] || "";
		const insert = "[...].";

		if (name.length > 32) name = name.slice(0, 32 - extension.length - insert.length) + insert + extension;
		if (extension.length > 32) {
			name = insert + extension.slice(32 - insert.length);
		}

		if (!file && !toUpload) {
			return null;
		}
		if (toUpload && !toUpload.name) {
			return null;
		}

		var preview = null;

		if (!this.state.preview && toUpload && toUpload.type && toUpload.type.indexOf("image") !== -1)
			this.getPreview(toUpload);

		if (format === "image" && url) {
			var source = {
				uri: url
			};
			preview = <Image resizeMethod="resize" style={styles.previewImage} source={source} />;
		} else if (format === "audio" && (url || file.uri)) {
			preview = <AudioPlayer noDownload={this.props.noDownload} url={url || file.uri} />;
		} else if (toUpload) {
			if (this.state.preview) {
				preview = <Image resizeMethod="resize" style={styles.previewImage} source={this.state.preview} />;
				format = "image";
			} else
				preview = (
					<View style={styles.newMessage}>
						<StyledText contrast={contrast} bold small>
							{newFile}
						</StyledText>
					</View>
				);
		}

		var iconName;
		if (format === "video") iconName = "video";
		else if (format === "image") iconName = "picture";
		else if (format === "document") iconName = "file";
		else if (format === "audio") iconName = "file-audio-o";
		else iconName = "files";

		return (
			<ListItem style={styles.listItemContainer}>
				<View>
					<View style={styles.contentContainer}>
						<StyledIcon name={iconName} />
						<ListContent>
							<StyledText contrast={contrast} style={styles.previewText}>
								{name}
							</StyledText>
						</ListContent>
					</View>
					<View style={styles.removeButtonContainer}>
						<StyledButton title={remove_title} icon="delete" alert onPress={onRemove} />
					</View>
				</View>
				<View>{preview}</View>
			</ListItem>
		);
	}
}

function getPreview(file) {
	return this.context.loadImage(file).then(
		function (image) {
			this.setState({
				preview: {
					uri: image
				}
			});
		}.bind(this)
	);
}

FilePreview.contextTypes = {
	localize: PropTypes.func,
	loadImage: PropTypes.func
};
